<template>
  <div :class="$style.wrap" v-if="overLoading">
    <base-form
      v-if="!showTip"
      :items="data"
      :actions="actions"
      :uploader="uploader"
      ref="form"
      label-width="5em"
      submit-text="确定"
      @actionShow="handlerAction"
      @setActionValue="setActionValue"
      @submit="onSubmit"
      @getData="getData"
    />
    <the-empty text="您提交的问题正在处理中，请耐心等待..." name="ask" v-else>
      <van-button
        round
        type="primary"
        size="large"
        tag="input"
        value="查看我的提单"
        native-type="submit"
        @click.stop.prevent="goPath"
      />
    </the-empty>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { feedbackInit, getRoleInfo, doFeedback } from "@/http/serve";
import { minxinForm } from "@/mixins/minxinForm";
import BaseForm from "@/components/BaseForm";
import TheEmpty from "@/components/TheEmpty";
export default {
  name: "ask",
  components: {
    BaseForm,
    TheEmpty
  },
  data() {
    return {
      overLoading: false,
      showTip: true, //显示等待处理提示
      count: 0,
      idList: {
        typeId: "", //类型Id
        serverId: "", //服务器Id
        serverName: "", //服务器Id
        roleId: "", //角色Id
        roleName: "" //角色Id
      },
      validator: null, // 极致验证
      actions: [], //picker选项
      uploader: {
        //上传图片初始化
        reqiure: false,
        isUploader: true,
        count: 3,
        text: "上传图片"
      },
      data: [
        {
          name: "typeProblem",
          readonly: true,
          iconType: 1,
          actions: []
        },
        {
          name: "server",
          readonly: true,
          iconType: 1,
          actions: []
        },
        {
          name: "characterName",
          readonly: true,
          iconType: 3,
          actions: []
        },
        { name: "telphone" },
        { name: "problemDes" }
      ]
    };
  },
  mixins: [minxinForm],
  mounted() {
    this.getFeedback();
  },
  computed: {
    ...mapGetters(["userInfo", "gameId"])
  },
  methods: {
    ...mapActions(["SetGame"]),
    /**
     * @description 前往账号申诉
     */
    goPath() {
      this.$router.replace({ path: this._anchor.lading.path });
    },
    /**
     * @description 获取游戏类型与服务器信息
     */
    async getFeedback() {
      if (!this.gameId) return;
      let parmas = {
        game_id: this.gameId
      };
      let res = await feedbackInit(parmas);
      let { rcode, data } = res;

      if (rcode == 3001) {
        this.showTip = true;
      } else if (rcode == 0) {
        this.showTip = false;
        let { question_tyoe_list, server_list } = data;
        question_tyoe_list.forEach(item => {
          item.type = 1;
        });
        server_list.forEach(item => {
          item.server = 1;
        });
        this.count = 0;
        this.setFieldValue("typeProblem", question_tyoe_list, "actions");
        this.setFieldValue("server", server_list, "actions");
      }
      this.overLoading = true;
    },
    /**
     * @description  获取角色信息
     */
    async getRoleInfo() {
      let { serverId } = this.idList;
      let parmas = {
        game_id: this.gameId,
        server_id: serverId
      };
      let res = await getRoleInfo(parmas);
      let { rcode, data } = res;
      if (rcode != 0) return;
      if (data.length == 0) {
        this.$Toast("未查询到角色，请重新选择服务器");
        this.setFieldValue("characterName", "");
        this.setFieldValue("characterName", 4, "iconType");
        this.setFieldValue("characterName", [], "actions");
        return false;
      }
      data.forEach(item => {
        item.role = 1;
      });
      this.setFieldValue("characterName", "");
      this.setFieldValue("characterName", 1, "iconType");
      this.setFieldValue("characterName", data, "actions");
    },
    /**
     * @description 提交问题
     * @param {object} formdata  - 表单对象值
     */
    async onSubmit(formdata) {
      let { telphone, problemDes } = formdata;
      let { typeId, serverId, roleId, serverName, roleName } = this.idList;
      let parmas = {
        game_id: this.gameId,
        question_type: typeId,
        server_id: serverId,
        phone_num: telphone,
        role_id: roleId,
        desc: problemDes,
        role_name: roleName,
        server_name: serverName
      };

      //如有图片
      if (this.$refs.form.uploadImg && this.$refs.form.uploadImg.length != 0) {
        parmas.pictures = this.$refs.form.uploadImg;
      }

      //问题与示例描述相同需提示
      let isExampleSome =
        this.getFieldValue("problemDes") ==
        this.getFieldValue("problemDes", "example");
      //问题与示例模板相同需提示
      let isTemplateSome =
        this.getFieldValue("problemDes") ==
        this.getFieldValue("problemDes", "template");

      if (isExampleSome || isTemplateSome) {
        this.count = 0;
        //问题描述与示例相同，问题描述变为模板
        isExampleSome &&
          this.setFieldValue(
            "problemDes",
            this.getFieldValue("problemDes", "template")
          );
        this.$Toast("请输入问题描述！");
        this.$refs.form.disabled = false;
        return false;
      }

      let res = await doFeedback(parmas);
      let { rcode } = res;
      if (rcode != 0) {
        this.$refs.form.disabled = false;
        return false;
      }
      if (rcode == 0) {
        this.$Toast({
          message: "提交成功",
          onClose: () => {
            this.$router.replace({
              path: this._anchor.lading.path
            });
          }
        });
      }
      this.$refs.form.disabled = false;
    },
    /**
     * @description picker控制选项
     */
    handlerAction(index) {
      this.actions = this.data[index].actions;
      //类型选择时，count变为0
      if (index == 0) {
        this.count = 0;
      }
    },
    /**
     * @description 设置picker选中值
     */
    setActionValue(index, item) {
      let { text, id, server, type, example, template, role } = item;
      this.$set(this.data[index], "value", text);
      if (server == 1) {
        this.$set(this.idList, "serverId", id);
        this.$set(this.idList, "serverName", text);
        this.setFieldValue("characterName", "value", "");
        this.getRoleInfo();
      }
      if (type == 1) {
        this.$set(this.idList, "typeId", id);
        this.setFieldValue("problemDes", example);
        this.setFieldValue("problemDes", example, "example");
        this.setFieldValue("problemDes", template, "template");
      }
      if (role == 1) {
        this.$set(this.idList, "roleId", id);
        this.$set(this.idList, "roleName", text);
      }
    },
    /**
     * @description 设置问题模板
     */
    setProblemTep(isFoucs, name) {
      let filed = "problemDes";
      let temp = "template";
      let exa = "example";

      //失焦后问题描述与模板相同.则变为示例
      let isSame = this.getFieldValue(filed) == this.getFieldValue(filed, temp);
      //失焦后问题描述都为空格
      let isAllEmpty =
        this.getFieldValue(filed) && this.getFieldValue(filed).length == 0;

      //聚焦后问题描述变为模板
      if (isFoucs && name == "problemDes" && this.count == 0) {
        this.count = +1;
        this.setFieldValue(filed, this.getFieldValue(filed, temp));
        return false;
      }

      //问题描述变为示例
      if (isSame || isAllEmpty) {
        this.count = 0;
        this.setFieldValue(filed, this.getFieldValue(filed, exa));
      }
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  padding-top: 1.3rem;
  padding-bottom: 2rem;

  :global {
    .van-uploader__preview {
      margin: 0 0.2rem 0.2rem 0;
    }
    .van-field--min-height .van-field__control {
      min-height: 100px;

      @media screen and (min-width: 750px) {
        min-height: 200px;
      }
    }
  }
}
.tip {
  .flex-col;
  .flex-center;
  .wait {
    .size(3.28rem);
    background: url("../images/wait.png");
    background-size: 100%;
    margin-top: 1rem;
  }
  .text {
    color: #48d5af;
    font-size: 0.3rem;
    margin: 0.5rem 0 1rem 0;
  }
}
</style>
